import { IonHeader, IonIcon, IonButton, IonPopover, useIonViewWillLeave, IonGrid, IonRow, IonCol, isPlatform } from '@ionic/react';
import React, { useState, useEffect, Ref } from 'react';
import './BibleReadingHeader.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { checkbox, square, ellipsisVertical, library } from 'ionicons/icons';
import { BibleVersionsValues } from '../../data/BibleVersions';
import BibleTextService from '../../services/BibleTextService';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { useHistory } from 'react-router-dom';
import BibleColorThemes, { BibleColorThemesValues } from '../../data/BibleColorThemes';

interface IBibleReadingHeaderProps extends IRouteInfo {
    previousReadingSessionUrl: string,
    nextReadingSessionUrl: string,
    menuContent: JSX.Element[] | JSX.Element,
    versionMenuContent: JSX.Element[] | JSX.Element,
    checkedBox: boolean,
    toggleReadDay: Function,
    bibleVersion: BibleVersionsValues,
    bibleReference: string,
    headerRef: Ref<HTMLIonHeaderElement>,
    readingPlanMenuContent: JSX.Element[] | JSX.Element,
    bibleColorTheme?: BibleColorThemesValues,
    isNoPlan: number,
}

const BibleReadingHeader: React.FC<IBibleReadingHeaderProps> = (props) => {
    const [showPageHeaderMenu, setShowPageHeaderMenu] = useState(false);
    const [pageHeaderMenuEvent, setPageHeaderMenuEvent] = useState<Event | undefined>(undefined);
    const [showVersionMenu, setShowVersionMenu] = useState(false);
    const [versionMenuEvent, setVersionMenuEvent] = useState<Event | undefined>(undefined);
    const [showPlanMenu, setShowPlanMenu] = useState(false);
    const [planMenuEvent, setPlanMenuEvent] = useState<Event | undefined>(undefined);
    const history = useHistory();

    useIonViewWillLeave(() => {
        setShowPageHeaderMenu(false); 
        setPageHeaderMenuEvent(undefined);
        setShowVersionMenu(false); 
        setPageHeaderMenuEvent(undefined);
    });

    useEffect(() => {
        setShowVersionMenu(false); 
        setPageHeaderMenuEvent(undefined);
    }, [props.bibleVersion])
    
  const getColorThemeClass = (colorTheme?: BibleColorThemesValues) => {
    switch(colorTheme) {
      case BibleColorThemes.darkMode:
        return 'bible-reading-dark-mode';
      default:
        return '';
    }
  }

    const navigatePlan = (noReadingPlanId: number) => {
        if(noReadingPlanId) {
            history.push(`${AppRouteInfo[AppRouteKeys.BibleNavigator].rootPath}/${noReadingPlanId}`, {direction: 'forward'});
        } else {
            history.push(AppRouteInfo[AppRouteKeys.BibleStudyBrowser].path, {direction: 'forward'});
        }
    }
  
    return (
        <IonHeader mode='ios' className="bible-study-header" ref={props.headerRef}>
            <IonGrid fixed={true} className="bible-study-header-toolbar">
                <IonRow className="bible-reading-header-row">
                    <IonCol className={isPlatform('desktop') ? 'bible-reading-header-reference bible-reading-header-desktop' : 'bible-reading-header-reference'}>
                        <div className="bible-reading-header-verse-version">
                        { !!props.bibleReference ? 
                            <span className="bible-reading-header-verse"  onClick={()=>{navigatePlan(props.isNoPlan)}}>
                                {(isPlatform('tablet') || isPlatform('desktop')) ? BibleTextService.convertToFullBookName(props.bibleReference) : props.bibleReference}
                            </span> :
                            <span className="bible-reading-header-verse">
                                Loading...
                            </span>}
                            <span className="bible-reading-header-version" onClick={e => {
                                setShowVersionMenu(true);
                                setVersionMenuEvent(e.nativeEvent);
                            }}>
                                {props.bibleVersion}
                            </span>
                        </div>
                    </IonCol>
                    <IonCol className="txt-right">
                        <IonButton className="bible-reading-header-plan-button" fill="clear" onClick={e => { 
                            setShowPlanMenu(true); 
                            setPlanMenuEvent(e.nativeEvent);
                        }}>
                            <IonIcon slot="icon-only" icon={library}/>
                        </IonButton>
                        {!props.isNoPlan && 
                            <IonButton fill="clear" onClick={() => {props.toggleReadDay()}}>
                                <IonIcon slot="icon-only" icon={props.checkedBox ?  checkbox : square}/>
                            </IonButton> }
                        <IonButton fill="clear" onClick={e => {
                            setShowPageHeaderMenu(true);
                            setPageHeaderMenuEvent(e.nativeEvent);
                        }} >
                            <IonIcon slot="icon-only" icon={ellipsisVertical} />
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonPopover
                className={getColorThemeClass(props.bibleColorTheme)}
                mode="md"
                dismissOnSelect={true}
                isOpen={showPageHeaderMenu}
                event={pageHeaderMenuEvent}
                onDidDismiss={() => {
                    setShowPageHeaderMenu(false); 
                    setPageHeaderMenuEvent(undefined);
                }}
            > {props.menuContent}</IonPopover>
            <IonPopover
                className={getColorThemeClass(props.bibleColorTheme)}
                mode="md"
                dismissOnSelect={true}
                isOpen={showVersionMenu}
                event={versionMenuEvent}
                onDidDismiss={() => {
                    setShowVersionMenu(false); 
                    setVersionMenuEvent(undefined);
                }}
            > {props.versionMenuContent}</IonPopover>
            <IonPopover
                className={`bible-reading-header-plan-menu ${getColorThemeClass(props.bibleColorTheme)}`}
                mode="md"
                dismissOnSelect={true}
                isOpen={showPlanMenu}
                event={planMenuEvent}
                onDidDismiss={() => {
                    setShowPlanMenu(false); 
                    setPlanMenuEvent(undefined);
                }}
            > {props.readingPlanMenuContent}</IonPopover>
        </IonHeader>
    );
};

export default BibleReadingHeader;